import { convertMetersToMiles } from '@/filters'
export function loadParams(loadInfo, hereInfo) {
    let { hereResultData } = hereInfo || {} 
    let { dispatchStopPointList } = loadInfo || {}
    let distance_arr = hereResultData.sections
    let stop_distance = distance_arr[0].summary.length
    let s_distance = distance_arr.length === 1 ? [] : distance_arr.slice(1)
    let result = dispatchStopPointList?.map((item, index) => {
        return {
           ...item,
           distance: convertMetersToMiles(s_distance[index]?.summary.length, 2) || ''
        }
    })
    return Object.assign({}, loadInfo, {dispatchStopPointList: distance_arr.length === 1 ? [] : result, stopDistance: convertMetersToMiles(stop_distance, 2)})
}